import { AntTootltip } from './styles';

export default AntTootltip;
